import {
	listProducts,
	approveProduct,
	rejectProduct,
	featureProduct,
} from '@/services/academy/productModeration.service'

export default {
	namespaced: true,
	state: {
		list: { data: [], meta: { pagination: { total: 0 } } },
		listStatus: 'init',
		actionStatus: 'init',
	},
	getters: {
		getList: (s) => s.list,
		getListStatus: (s) => s.listStatus,
		getActionStatus: (s) => s.actionStatus,
	},
	mutations: {
		SET_LIST(state, v) { state.list = v },
		SET_LIST_STATUS(state, v) { state.listStatus = v },
		SET_ACTION_STATUS(state, v) { state.actionStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listProducts(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async approve({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await approveProduct(payload)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
		async reject({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await rejectProduct(payload)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
		async feature({ commit }, payload) {
			commit('SET_ACTION_STATUS', 'pending')
			try {
				await featureProduct(payload)
				commit('SET_ACTION_STATUS', 'success')
			} catch (e) {
				commit('SET_ACTION_STATUS', 'error')
				throw e
			}
		},
	},
}
